function glyph(body, strokeWidth = 1.75) {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`;
}

const ICONS = {
  undo: glyph('<path d="M9 14L4 9l5-5"></path><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"></path>'),
  redo: glyph('<path d="M15 14l5-5-5-5"></path><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"></path>'),
  reset: glyph('<path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v4.5h4.5"></path>'),
  eye: glyph('<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"></path><circle cx="12" cy="12" r="2.8"></circle>', 1.8),
  'eye-off': glyph('<path d="M10 5.7A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a16 16 0 0 1-2.6 3.4M6.4 6.9C3.9 8.6 2.5 12 2.5 12S6 18.5 12 18.5c1.8 0 3.3-.5 4.6-1.3M3.5 3.5l17 17M9.9 9.9a2.8 2.8 0 0 0 4.2 4.2"></path>', 1.8),
  duplicate: glyph('<rect x="8.5" y="8.5" width="12" height="12" rx="2.5"></rect><path d="M15.5 8.5V5.5a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3"></path>', 1.8),
  'lock-open': glyph('<rect x="5" y="10.5" width="14" height="10" rx="2.5"></rect><path d="M8 10.5V7.5a4 4 0 0 1 7.6-1.8"></path>', 1.8),
  lock: glyph('<rect x="5" y="10.5" width="14" height="10" rx="2.5"></rect><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"></path>', 1.8),
  trash: glyph('<path d="M4.5 7h15M10 11v6M14 11v6M6.5 7l.9 12.5a1.5 1.5 0 0 0 1.5 1.5h6.2a1.5 1.5 0 0 0 1.5-1.5L17.5 7M9.5 7V4.5h5V7"></path>', 1.8),
  'chevron-down': glyph('<path d="M6 9l6 6 6-6"></path>', 2),
  'chevron-right': glyph('<path d="M9 6l6 6-6 6"></path>', 2),
  folder: glyph('<path d="M3.5 7.5a2 2 0 0 1 2-2h4l2 2.5h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z"></path>'),
  'remove-group': glyph('<path d="M3.5 7.5a2 2 0 0 1 2-2h4l2 2.5h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z"></path><path d="M9 14h6M13 11.5l2.5 2.5-2.5 2.5"></path>'),
  text: glyph('<path d="M5 7V5h14v2M9.5 19h5M12 5v14"></path>'),
  circle: glyph('<circle cx="12" cy="12" r="8"></circle>'),
  table: glyph('<rect x="3.5" y="4.5" width="17" height="15" rx="2"></rect><path d="M3.5 9.5h17M3.5 14.5h17M9.5 9.5v10"></path>'),
  image: glyph('<rect x="3.5" y="4" width="17" height="16" rx="2.5"></rect><circle cx="9" cy="9.5" r="1.8"></circle><path d="M20.5 15.5l-5-5L5 20"></path>'),
  rect: glyph('<rect x="4.5" y="5.5" width="15" height="13" rx="2"></rect>'),
  shape: glyph('<rect x="4.5" y="5.5" width="15" height="13" rx="2"></rect>'),
  polygon: glyph('<path d="M12 3.5l6.8 4.9-2.6 8.1H7.8L5.2 8.4z"></path>'),
  shield: glyph('<path d="M12 3l7.5 3v5.5c0 4.6-3.2 8.3-7.5 9.5-4.3-1.2-7.5-4.9-7.5-9.5V6z"></path><path d="M9 12l2.2 2.2L15.5 10"></path>'),
  house: glyph('<path d="M3.5 11L12 4l8.5 7"></path><path d="M6 9.5V20h12V9.5"></path><path d="M9.5 14h5M9.5 17h5"></path>'),
  mail: glyph('<rect x="3" y="5" width="18" height="14" rx="2.5"></rect><path d="M3.5 7.5l8.5 6 8.5-6"></path>'),
  video: glyph('<rect x="2.5" y="6" width="13" height="12" rx="2.5"></rect><path d="M15.5 10.5l6-3v9l-6-3z"></path>'),
  audio: glyph('<path d="M9 18V5.5l11-2v12.5"></path><circle cx="6" cy="18" r="3"></circle><circle cx="17" cy="16" r="3"></circle>'),
};

export function getLayerGlyph(name) {
  if (ICONS[name]) { return ICONS[name]; }
  try {
    return require(`@/assets/icons/${name}.svg`);
  } catch (e) {
    return ICONS.shape;
  }
}

export function getLayerIconName(layer) {
  if (!layer) { return 'shape'; }
  const { type, shapeType, ImageType } = layer;
  if (type === 'group') { return 'folder'; }
  if (type === 'shape') {
    if (shapeType === 'rectangle') { return 'rect'; }
    if (shapeType === 'ellipses') { return 'circle'; }
    if (shapeType === 'polygon') { return 'polygon'; }
    return 'shape';
  }
  if (type === 'table') { return 'table'; }
  if (type === 'image') {
    if (ImageType === 'WhiteboxLogo' || ImageType === 'IndependentWhitebox') { return 'mail'; }
    if (ImageType === 'FDICText' || ImageType === 'FDICTextWhite') { return 'shield'; }
    if (ImageType === 'FDICLogo' || ImageType === 'FDICLogoWhite') { return 'house'; }
    return 'image';
  }
  if (type === 'text') { return 'text'; }
  if (type === 'video') { return 'video'; }
  if (type === 'audio') { return 'audio'; }
  return 'shape';
}
